<script lang="ts">
	import Moon from 'lucide-svelte/icons/moon';
	import Sun from 'lucide-svelte/icons/sun';
	import { setMode } from 'mode-watcher';
	import { buttonVariants } from '$lib/components/ui/button';
	import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
	import { cn } from '$lib/utils.js';
	import Cookies from 'js-cookie';

	const set = (mode: 'light' | 'dark' | 'system') => {
		setMode(mode);
		Cookies.set('mode-watcher', mode, {
			path: '/'
		});
	};
</script>

<DropdownMenu.Root>
	<DropdownMenu.Trigger class={cn(buttonVariants({ variant: 'ghost', class: 'w-6 px-0' }))}>
		<Sun
			class="dark:-roate-90 h-[1.2rem] w-[1.2rem] rotate-0 scale-100 transition-all dark:scale-0"
		/>
		<Moon
			class="absolute h-[1.2rem] w-[1.2rem] rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100"
		/>
		<span class="sr-only">Toggle theme</span>
	</DropdownMenu.Trigger>
	<DropdownMenu.Content align="end">
		<DropdownMenu.Item onclick={() => set('light')}>Light</DropdownMenu.Item>
		<DropdownMenu.Item onclick={() => set('dark')}>Dark</DropdownMenu.Item>
		<DropdownMenu.Item onclick={() => set('system')}>System</DropdownMenu.Item>
	</DropdownMenu.Content>
</DropdownMenu.Root>
